import React, { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import {
  HrParagraph,
  HrFlexContainer,
  HrTitleContainer,
  HrTitleH4,
  HrButtons,
  HrWhite,
  HrRed,
  HrIconText
} from '@components/styles/hr-styles';
import { Input } from '@components/form/input';
import { HrButton } from '@components/button/button';
import { Modal } from '../modal';
import { postPostulantEmailExist, postPostulantEmailSend } from '../../services/api';
import { DisplaySettingsContext } from '../../store/display-settings';

export const UpdateProfile = ({ setShowModal, vacancy, setShowModalUpdateProfileSuccessful, mail }) => {
  const [t] = useTranslation();
  const [load, setLoad] = useState(false);
  const [error, setError] = useState({
    mailNoExist: false,
    errorResend: false
  });

  const {
    handleSubmit: handleSubmitUpdateProfile,
    register: registerUpdateProfile,
    formState: formStateUpdateProfile,
    getValues,
    setValue
  } = useForm({
    mode: 'all'
  });

  useEffect(() => {
    setValue('mailUpdatePostulant', mail);
  }, [mail]);

  const _handleSubmitUpdateProfile = () => {
    setLoad(true);
    setError((prev) => {
      return { ...prev, mailNoExist: false, errorResend: false };
    });
    const postulantEmail = getValues('mailUpdatePostulant');
    const prom = postPostulantEmailExist(postulantEmail, vacancy._id.$oid, vacancy.account);

    prom
      .then((res) => {
        const { result } = res.data;
        if (result === 'false') {
          setError((prev) => {
            return { ...prev, mailNoExist: true, errorResend: false };
          });
          setLoad(false);
        } else if (result === 'true') {
          postPostulantEmailSend(postulantEmail, vacancy.account)
            .then((resultProm) => {
              const { success } = resultProm.data;
              if (success) {
                setLoad(false);
                setShowModal(false);
                setShowModalUpdateProfileSuccessful(true);
              }
            })
            .catch((error) => {
              setLoad(false);
              setError((prev) => {
                return { ...prev, mailNoExist: false, errorResend: true };
              });
            });
        }
      })
      .catch((error) => {
        setLoad(false);
        setError((prev) => {
          return { ...prev, mailNoExist: false, errorResend: true };
        });
      });
  };

  const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

  return (
    <Modal setShowModal={setShowModal}>
      <HrTitleContainer padding='32px 24px 16px 24px' gap='4px'>
        <span style={{color : darkMode ? 'white' : ''}} className='hr-Change' />
        <HrTitleH4 fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''}>{t('postulant.modal.update_profile.title')}</HrTitleH4>
      </HrTitleContainer>
      <HrFlexContainer flexDirection='column' padding='24px'>
        <HrParagraph fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''}>{t('postulant.modal.update_profile.text')}</HrParagraph>
        <HrFlexContainer flexDirection='column' alignItems='flex-start'>
          <Input
            title={t('postulant.mail')}
            placeholder={t('postulant.placeholder.mail')}
            name='mailUpdatePostulant'
            type='text'
            register={registerUpdateProfile}
            formState={formStateUpdateProfile}
            validate={{
              required: true,
              mail: true
            }}
          />

          {error.mailNoExist && (
            <HrIconText color={HrRed} style={{ marginTop: '2px' }}>
              <span className='hr-Alert' />
              {t('postulant.modal.update_profile.error_mail_not_exist')}
            </HrIconText>
          )}
          {error.errorResend && (
            <HrIconText color={HrRed} style={{ marginTop: '2px' }}>
              <span className='hr-Alert' />
              {t('postulant.modal.update_profile.error_resend')}
            </HrIconText>
          )}
        </HrFlexContainer>
        <HrFlexContainer justifyContent='space-between'>
          <HrButtons
            type='button'
            category='cancel'
            size='medium'
            style={{fontSize: `${14 + fontSizeSetting}px`}}
            onClick={() => {
              setShowModal(false);
            }}
          >
            {t('general.button.cancel')}
          </HrButtons>
          <HrButton
            type='button'
            name='submit'
            category='primary'
            size='medium'
            onClick={handleSubmitUpdateProfile(_handleSubmitUpdateProfile)}
            text={t('general.button.send')}
            fontSize={`${14 + (fontSizeSetting || 0)}px`}
            iconColor={HrWhite}
            loading={load}
            disabled={load}
          />
        </HrFlexContainer>
      </HrFlexContainer>
    </Modal>
  );
};
